<section class="value-list" [attr.aria-label]="getTableHeaderName()" [attr.aria-busy]="faultyVehicleDataService.isLoading()">
    <div class="list-heading"><h2>{{ getTableHeaderName() }}</h2><span>{{ faultyVehicleDataService.totalElements() | number }} values</span></div>
        <div class="table-container" infinite-scroll [scrollWindow]="false"
             [infiniteScrollDistance]="2" [infiniteScrollThrottle]="150"
             [infiniteScrollDisabled]="!faultyVehicleDataService.canLoadMore()"
             (scrolled)="faultyVehicleDataService.onScroll()">
            <table>
                <thead><tr><th scope="col">Value</th><th scope="col" class="count-column">Pure Originals</th></tr></thead>
                <tbody>
                @for (element of faultyDataList(); track element.value) {
                    <tr [class.active]="selectedValue() === element.value">
                        <td><button type="button" class="value-select" [attr.aria-pressed]="selectedValue() === element.value"
                                    (click)="selectFaultyValue(element)">
                            <span [title]="element.value">{{ element.value || '(Empty value)' }}</span><i class="bi bi-chevron-right" aria-hidden="true"></i>
                        </button></td>
                        <td class="count-column"><span class="count-badge">{{ element.count == null ? '—' : (element.count | number) }}</span></td>
                    </tr>
                } @empty {
                    @if (!faultyVehicleDataService.isLoading() && !faultyVehicleDataService.error()) {
                    <tr><td colspan="2" class="empty-state">No faulty values found.</td></tr>
                    }
                }
                </tbody>
            </table>
            @if (faultyVehicleDataService.isLoading()) {
                <div class="list-state" [class.more-state]="faultyDataList().length > 0" role="status"><i class="bi bi-arrow-repeat" aria-hidden="true"></i>Loading values…</div>
            } @else if (faultyVehicleDataService.error()) {
                <div class="list-state" [class.more-state]="faultyDataList().length > 0" role="alert"><p>{{ faultyVehicleDataService.error() }}</p><button type="button" (click)="faultyVehicleDataService.retry()">Retry</button></div>
            }
        </div>
</section>
